<template>
  <div class="info-tooltip">
    <img
      class="info-icon"
      src="@/assets/icons/ui/information-circle-outline.svg"
      alt="more info icon"
    />
    <div class="info-tooltip-text">
      <div class="information-hover__content">
        <div class="information-hover__content__title" v-if="title">
          <h3>{{ title }}</h3>
        </div>
        <div class="information-hover__content__description">
          <p>{{ description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InformationHover",
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
/* info-tooltip container */
.info-tooltip {
  position: relative;
}

/* info-tooltip text */
.info-tooltip .info-tooltip-text {
  visibility: hidden;
  min-width: 200px;
  background-color: #4c4c51;
  color: #fff;
  text-align: center;
  padding: .8rem;
  border-radius: 6px;

  /* Position the info-tooltip text */
  position: absolute;
  z-index: 1;
  top: 125%;
  left: 50%;
  margin-left: -20px;

  /* Fade in info-tooltip */
  opacity: 0;
  transition: opacity 0.2s;

  h3,
  p {
    color: #fff;
    font-size: .85rem;
    font-weight: 400;
  }
}

/* info-tooltip arrow */
.info-tooltip .info-tooltip-text::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 0%;
  margin-left: 15px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #4c4c51 transparent;
}

/* Show the info-tooltip text when you mouse over the info-tooltip container */
.info-tooltip:hover .info-tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>